import { ReactNode } from "react";

import { Button } from "@/components/ui/Button";
import { Notice } from "@/components/ui/Notice";

interface InlineErrorProps {
  children: ReactNode;
  /** Offered when trying again can help, e.g. after a failed load */
  onRetry?: () => void;
}

/** An error shown where it happened, read left to right with its way out beside it. */
export const InlineError = ({ children, onRetry }: InlineErrorProps) => (
  <Notice
    tone="error"
    role="alert"
    action={
      onRetry && (
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      )
    }
  >
    {children}
  </Notice>
);
